export default "__VITE_ASSET__BDXRbfWv__"